export default {"src":"/_next/static/media/arrow-right-submit-black.054bf138.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};